































































import Vue from "vue";
import { getEventsPaymentOptions } from "@/modules/event/payment-options.service";

export default Vue.extend({
  name: "SubscriptionPaymentDetails",
  props: ["subscription", "eventId", "paymentOptions", "admin", "edition"],
  data: () => ({
    paymentOptionsData: [],
  }),
  async mounted() {
    if (this.paymentOptions && this.paymentOptions.length > 0) {
      this.paymentOptionsData = this.paymentOptions;
    } else {
      await getEventsPaymentOptions(this.eventId).then((res) => {
        if (res.data) {
          this.paymentOptionsData = res.data;
        } else if (res.error) {
          console.log(
            "Erreur. Impossible de récupérer les données pour le paiement."
          );
        }
      });
    }
  },
  computed: {
    paymentOptionLabel() {
      if (!this.subscription.paymentOptionsId) return "";
      return (
        this.paymentOptionsData.find(
          (paymentOption) =>
            paymentOption.id === this.subscription.paymentOptionsId
        )?.label || ""
      );
    },
    paymentStatusOptions() {
      return [
      { text: 'A traiter', value: 'TOPROCESS' },
      { text: 'En attente', value: 'PENDING' },
      { text: 'Payé', value: 'PAYED' },
      { text: 'Annulé', value: 'CANCELLED' },
      { text: 'Autre', value: 'OTHER' },
      ]
    }
  },
  methods: {
    changePaymentStatus(status: string){
      this.$emit('paymentStatus',status)
    },
    changePaymentRef(ref: string){
      this.$emit('paymentRef',ref)
    },
    handleClick() {
      this.$emit("click");
    },
    close(reset: boolean) {
      this.handleClick();
    },
  },
});
